import React, { useState, useRef } from 'react'
import './ChavesCertificadoForm.scss'
import { Password } from 'primereact/password'
import LtsTextArea from '../../../components/lottus/lts-text-area'
import { FileUpload } from 'primereact/fileupload'
import { Button } from 'primereact/button'
import api from '../../../services/api.service'
import { Toast } from 'primereact/toast'

export const ChavesCertificadoForm = () => {
  const [senha, setSenha] = useState('')
  const [certificado, setCertificado] = useState(null)
  const [chavePublica, setChavePublica] = useState('')
  const [chavePrivada, setChavePrivada] = useState('')
  const [exibirChaves, setExibirChaves] = useState(false) // Controle da exibição das chaves
  const fileUploadRef = useRef(null)
  const toast = useRef(null)

  const handleFileUpload = ({ files }) => {
    setCertificado(files[0])
  }

  const handleExtrairChaves = async () => {
    if (!certificado) {
      toast.current.show({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'Por favor, selecione um arquivo de certificado.',
        life: 3000,
      })
      return
    }

    const formData = new FormData()
    formData.append('file', certificado)

    if (senha) {
      formData.append('password', senha)
    }

    try {
      const response = await api.postFormData('/lottustech/certificado/extrairChaves', formData)
      const { chavePublica, chavePrivada } = response.data
      setChavePublica(chavePublica)
      setChavePrivada(chavePrivada)
      setExibirChaves(true) // Exibir chaves após sucesso
      toast.current.show({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Chaves extraídas com sucesso.',
        life: 3000,
      })
    } catch (error) {
      toast.current.show({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro ao extrair chaves do certificado.',
        life: 3000,
      })
      console.error(error)
    }
  }

  const handleCopiarTexto = (texto) => {
    navigator.clipboard.writeText(texto)
    toast.current.show({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Texto copiado para a área de transferência',
      life: 3000,
    })
  }

  const handleBaixarChave = (chave, nomeArquivo) => {
    const blob = new Blob([chave], { type: 'text/plain' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = nomeArquivo
    link.click()
  }

  const handleClear = () => {
    setCertificado(null)
    setChavePublica('')
    setChavePrivada('')
    setSenha('') // Limpar o campo de senha
    setExibirChaves(false) // Ocultar as chaves
    fileUploadRef.current.clear()
  }

  return (
    <div>
      <Toast ref={toast} />
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <div className="card">
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-8 p-md-6 p-lg-6">
                <span className="p-float-label">
                  <Password
                    type="text"
                    name="senha"
                    feedback={false}
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                  />
                  <label>Senha do certificado (opcional)</label>
                </span>
              </div>

              <div className="p-col-12 p-sm-4 p-md-6 p-d-flex p-ai-center">
                <FileUpload
                  ref={fileUploadRef}
                  name="certificado"
                  accept=".pfx"
                  maxFileSize={1000000}
                  customUpload
                  auto={false}
                  chooseLabel="Escolher arquivo"
                  mode="basic"
                  multiple={false}
                  onSelect={handleFileUpload}
                />
              </div>
            </div>

            <div className="p-grid">
              <div className="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-6">
                <div className="btn-container">
                  <Button
                    label="Extrair Chaves"
                    icon="pi pi-key"
                    onClick={handleExtrairChaves}
                  />
                  <Button
                    label="Limpar"
                    icon="pi pi-times"
                    className="p-button-danger"
                    onClick={handleClear}
                    style={{ marginLeft: '10px' }}
                  />
                </div>
              </div>
            </div>
          </div>

          {exibirChaves && (
            <div className="card">
              <div className="p-grid">
                <div className="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-6">
                  <div className="btn-container">
                    <Button
                      label="Copiar chave pública"
                      icon="pi pi-copy"
                      onClick={() => handleCopiarTexto(chavePublica)}
                    />
                    <Button
                      label="Baixar chave pública"
                      icon="pi pi-download"
                      onClick={() => handleBaixarChave(chavePublica, 'chavePublica.txt')}
                    />
                  </div>
                </div>

                <div className="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-6">
                  <div className="btn-container">
                    <Button
                      label="Copiar chave privada"
                      icon="pi pi-copy"
                      onClick={() => handleCopiarTexto(chavePrivada)}
                    />
                    <Button
                      label="Baixar chave privada"
                      icon="pi pi-download"
                      onClick={() => handleBaixarChave(chavePrivada, 'chavePrivada.txt')}
                    />
                  </div>
                </div>
              </div>

              <div className="p-grid form-group">
                <div className="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-6">
                  <LtsTextArea
                    name="chavePublica"
                    label={'Chave pública do certificado'}
                    rows={10}
                    value={chavePublica}
                    readOnly
                    autoResize={false}
                  />
                </div>

                <div className="p-col-12 p-sm-12 p-md-12 p-lg-6 p-xl-6">
                  <LtsTextArea
                    name="chavePrivada"
                    label={'Chave privada do certificado'}
                    rows={10}
                    value={chavePrivada}
                    readOnly
                    autoResize={false}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
